import moment from "moment-timezone";

const DEFAULT_TIMEZONE = moment.tz.guess() || "UTC";

const pickTimezoneValue = (timezoneResponse) => {
  if (!timezoneResponse) {
    return null;
  }

  if (typeof timezoneResponse === "string") {
    return timezoneResponse;
  }

  if (typeof timezoneResponse === "object") {
    if (timezoneResponse.data && timezoneResponse.data !== timezoneResponse) {
      return pickTimezoneValue(timezoneResponse.data);
    }

    return timezoneResponse.timezone ||
      timezoneResponse.timeZone ||
      timezoneResponse.timezoneId ||
      timezoneResponse.zoneId ||
      timezoneResponse.name ||
      timezoneResponse.id ||
      timezoneResponse.value;
  }

  return null;
};

export const normalizeTimezone = (timezoneResponse) => {
  const timezone = pickTimezoneValue(timezoneResponse);

  return moment.tz.zone(timezone) ? timezone : DEFAULT_TIMEZONE;
};

export const formatCurrentDateInTimezone = (timezone) => {
  return moment().tz(normalizeTimezone(timezone)).format('YYYY-MM-DDTHH:mm:ssZZ');
};

export const formatMonthStartInTimezone = (year, monthIndex, timezone) => {
  return moment.tz(
    year + '-' + (monthIndex + 1) + '-01',
    'YYYY-M-DD',
    normalizeTimezone(timezone)
  ).format('YYYY-MM-DDTHH:mm:ssZZ');
};

export const formatSlotDateInTimezone = (date, timezone) => {
  return moment.tz(date, normalizeTimezone(timezone));
};
